import(/* webpackMode: "eager" */ "/codebuild/output/src1014875322/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/global-error.tsx");
